module.exports = __webpack_public_path__ + "static/media/o9.5968fa15.png";